import { createRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { AppState } from 'src/AppState';
import { EasyClaimDocumentType } from 'src/easyclaim.api.client.typescript/src';
import { SolvdCamera } from 'src/easyclaim.app.assets/icons/SolvdCamera';
import { CarFrontLeftPlaceholder } from 'src/easyclaim.app.components/common/ImageRepository';
import { ImageSelectionService } from 'src/easyclaim.app.services/ImageSelectionService';

import { SelectImageBase } from '../../easyclaim.app.components/common/SelectImage';
import { ImageFileInputType, SelectImage } from '../../easyclaim.app.components/index';
import { ScreenComponent } from '../ScreenComponent';

interface VehicleFrontLeftPerspectiveImageProps extends AppState {
	isPreview?: boolean;
}

interface PolicyCheckVehicleImagesState {}

export class VehicleFrontLeftPerspectiveImage extends ScreenComponent<
	VehicleFrontLeftPerspectiveImageProps,
	PolicyCheckVehicleImagesState
> {
	private selectImageRef = createRef<SelectImageBase>();

	constructor(props: VehicleFrontLeftPerspectiveImageProps) {
		super(props);
	}

	public componentDidMount() {
		if (!this.props.isPreview) {
			super.componentDidMount();
		}
	}

	public render() {
		return (
			<div className="main-container photo-main-container">
				<FormattedMessage id="vehicleFrontLeftPerspectiveImage.description" />
				<SelectImage
					ref={this.selectImageRef}
					componentId="vehicleFrontLeft"
					imageFileInputType={ImageFileInputType.CapturePicture}
					fileType={EasyClaimDocumentType.FrontLeftPicture}
					caseId={this.props.easyClaimCase?.caseId}
					easyClaimService={this.props.easyClaimService}
					currentImage={this.props.vehicleImageFrontLeft}
					title="vehicleImages.leftFrontOverview"
					placeholder={<CarFrontLeftPlaceholder />}
					marginBottom="1rem"
					onChange={(image) => {
						if (this.props.isPreview) {
							return;
						}

						const isImageLoading = ImageSelectionService.isImageLoading(image);

						const newState = Object.assign({}, this.props, {
							vehicleImageFrontLeft: image,
							isImageLoading: isImageLoading,
						});

						void this.props.setAppState(newState);
					}}
					showUserFeedbackInfo={true}
					configuration={this.props.easyClaimCase!._configuration!}
					inputError={this.props.inputError}
					vehicleType={this.props.easyClaimCase?.vehicle?.vehicleTypeId}
					disableUpdate={this.props.isPreview}
					disableContainerClick={this.props.isPreview || Boolean(this.props.vehicleImageFrontLeft)}
				/>
				<button
					disabled={this.props.isPreview}
					className={`button-take-photo ${this.props.vehicleImageFrontLeft ? 'hidden' : ''}`}
					onClick={() => this.selectImageRef.current?.onContainerClick(false)}
				>
					<SolvdCamera />
					<FormattedMessage id="button.photo.take" />
				</button>
			</div>
		);
	}
}
